module.exports = __webpack_public_path__ + "static/filter-7c7f78d7d7b8d3d5a6dc60ecd5a62b56.svg";